export default {
  robotoRegular: "Roboto-Regular, sans-serif",
  robotoMedium: "Roboto-Medium, sans-serif",
  robotoBold: "Roboto-Bold, sans-serif",
  robotoLight: "Roboto-Light, sans-serif"
};